"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.t = void 0;
var t_1 = require("./t");
Object.defineProperty(exports, "t", { enumerable: true, get: function () { return __importDefault(t_1).default; } });
